import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useGetInsuranceAdditionalDates, useSaveInsuranceAdditionalDates } from '@/hooks/useInsuranceParams'
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, useToast } from '@chakra-ui/react'
import type { InsuranceAdditionalDatesModel } from 'BrokerTsLib/src/dtos'
import { formatDate } from 'BrokerTsLib/src/Utils/formatPrice'
import cloneDeep from 'lodash/cloneDeep'
import { useEffect } from 'react'
import { AddInsuranceAdditionalDatesForm } from '../AddInsuranceAdditionalDatesForm'
import { Loading } from '../Loading'
import { WizzardHeaderButton } from './WizzardHeaderButton'

function AddInsuranceAdditionalDates() {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const toast = useToast()
  const { insuranceParamsId } = useInsuranceParams()

  const { data, refetch, isLoading, isFetched } = useGetInsuranceAdditionalDates(insuranceParamsId!, { enabled: false })
  const { mutateAsync: saveAdditionalDates } = useSaveInsuranceAdditionalDates()

  useEffect(() => {
    refetch()
  }, [])

  const handleFormSubmit = (values: InsuranceAdditionalDatesModel) => {
    const data = cloneDeep(values)
    data.contractDeliveryDate = formatDate(values.contractDeliveryDate)
    data.commissionPaidDate = formatDate(values.commissionPaidDate)
    data.firstPaymentDate = formatDate(values.firstPaymentDate)

    return saveAdditionalDates(data)
      .then(() => {
        refetch()
        toast({
          title: 'Informace byly uloženy.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        })
      })
      .catch(() => {
        toast({
          title: 'Chyba při ukládání',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
      })
      .finally(() => onClose())
  }

  return (
    <>
      <WizzardHeaderButton onClick={onOpen}>
        Doplnit datumy
      </WizzardHeaderButton>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />

          <ModalHeader>Doplnění datumů</ModalHeader>


          <ModalBody>
            {isLoading && <Loading large />}
            {!isLoading && isFetched && data?.data && <AddInsuranceAdditionalDatesForm onSubmit={handleFormSubmit} data={data!.data} />}
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default AddInsuranceAdditionalDates